import PoleVue from '@/components/pole/PoleVue'
import PoleList from '@/components/pole/PoleList'
import PoleCreate from '@/components/pole/PoleCreate'

export default [
  {
    path: '/poles',
    name: 'PoleList',
    component: PoleList,
    meta: {
      parentName: 'Home',
      requiresAuth: true,
      needProfile: ['admin']
    }
  },
  {
    path: '/poles/creation',
    name: 'PoleCreate',
    component: PoleCreate,
    meta: {
      parentName: 'PoleList',
      requiresAuth: true,
      needProfile: ['admin'],
      maxHeight: true
    }
  },
  {
    path: '/poles/:id',
    name: 'PoleVue',
    component: PoleVue,
    meta: {
      parentName: 'PoleList',
      requiresAuth: true,
      needProfile: ['admin'],
      maxHeight: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/poleRouter.js